<yc-typeahead-select
  [disabled]="isViewOnly"
  [items]="evaluationTypeSelectOptions"
  [value]="evaluationType"
  (valueChange)="handleEvaluationTypeChange($event)">
</yc-typeahead-select>